// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feedItemHeader":"_3n7Yu3cA78UwPEllc-sUU_"};